export const es = {
  // Main namespace - used by filter components from old app
  main: {
    titularidad: 'Titularidad',
    'titularidad-privado': 'PRIVADO',
    'titularidad-publico': 'PÚBLICO',
    'titularidad-municipal': 'MUNICIPAL',
    'titularidad-todo': 'TODO',
    ref_catastral_search: 'Buscar referencia catastral',
    ref_catastral_placeholder: 'Ej. 06001A123456789A',
    field_report: 'Informe de campo',
    cadastral_actions_for: 'Acciones para',
    cadastral_upload_pick_muni: 'Selecciona un municipio para subir archivos.',
    open_in_map: 'Ver en el mapa',
    upload_lab_measures: 'Muestra de laboratorio',
    upload_field_report: 'Informe de campo',
    field_report_details: 'Datos del informe de campo',
    field_report_before_upload:
      'Antes de subir, indica el tipo del elemento y el tipo de amianto observados.',
    field_report_uploaded: 'Informe de campo subido — edificio marcado como Detallado',
    upload_and_mark_detailed: 'Subir y marcar Detallado',
    document_uploaded: 'Documento subido',
    document_upload_error: 'Error al subir el documento',
    uso_del_edificio: 'Uso del edificio',
    uso_del_edificio_Industrial: 'Industrial',
    uso_del_edificio_Agrícola: 'Agrícola',
    uso_del_edificio_Retail: 'Retail',
    uso_del_edificio_Oficinas: 'Oficinas',
    'uso_del_edificio_Servicios Públicos': 'Servicios Públicos',
    uso_del_edificio_Residencial: 'Residencial',
    uso_del_edificio_Otros: 'Otros',
    asbestos_susceptibility: 'Cribado de contener amianto',
    susceptibility_title: 'Cribado mínimo de contener amianto representado',
    susceptibility_label_baja: 'Baja',
    susceptibility_label_media: 'Media',
    susceptibility_label_alta: 'Alta',
    susceptibility_label_muy_alta: 'Muy alta',
    // Map loading
    loading_boundary: 'Cargando delimitación...',
    public_view: 'Vista pública',
    municipal_boundary: 'Límite municipal',
    // Dashboard translations
    dashboard_title: 'Dashboard de Amianto - Grupo de capas',
    dashboard_loading: 'Cargando estadísticas...',
    dashboard_error_loading: 'Error al cargar estadísticas',
    dashboard_no_layer_group: 'No hay grupo de capas seleccionado',
    dashboard_tab_grid: 'GRID',
    dashboard_tab_susceptibility: 'CRIBADO',
    dashboard_tab_censo: 'TELEDETECCIÓN',
    dashboard_no_grid_data: 'No hay datos de cuadrícula disponibles',
    dashboard_no_susceptibility_data: 'No hay datos de cribado disponibles',
    dashboard_no_censo_data: 'No hay datos de teledetección disponibles',
    // Grid Dashboard
    dashboard_grid_title: 'Dashboard GRID - Estimación de Tiempos',
    dashboard_total_time: 'Tiempo total estimado de procesamiento',
    dashboard_remaining_time: 'Tiempo restante estimado de procesamiento',
    dashboard_summary_by_category: 'Resumen por categorías',
    dashboard_cells_by_status: 'Número de celdas por categoría y estado',
    dashboard_completion_percentage: 'Porcentaje completado del proyecto',
    dashboard_total_cells: 'Total celdas',
    dashboard_completed: 'Completado',
    dashboard_pending: 'Pendiente',
    // Susceptibility Dashboard
    dashboard_susceptibility_title: 'Dashboard CRIBADO',
    dashboard_total_buildings: 'Total edificios',
    dashboard_unique_cadastral_refs: 'Refs. catastrales únicas',
    dashboard_avg_building_age: 'Edad media edificios',
    dashboard_total_area_m2: 'Área total (m²)',
    dashboard_by_level: 'Por nivel de cribado',
    dashboard_by_use: 'Por uso del edificio',
    dashboard_by_owner: 'Por titularidad',
    dashboard_by_decade: 'Por década de construcción',
    // Censo Dashboard
    dashboard_censo_title: 'Dashboard TELEDETECCIÓN',
    dashboard_total_elements: 'Total elementos',
    dashboard_total_m2_amianto: 'Total m² amianto',
    dashboard_total_m3_amianto: 'Total m³ amianto',
    dashboard_by_asbestos_presence: 'Por presencia de amianto',
    dashboard_years: 'años',
    // Grid status translations
    grid_status_pending: 'Pendiente',
    grid_status_in_progress: 'En progreso',
    grid_status_in_review: 'En revisión',
    grid_status_reviewed: 'Revisado',
    grid_status_clear: 'Completado',
    // Susceptibility levels
    susceptibility_level_baja: 'Baja',
    susceptibility_level_media: 'Media',
    susceptibility_level_alta: 'Alta',
    susceptibility_level_muy_alta: 'Muy Alta',
    // Asbestos presence
    asbestos_presence_MCA: 'MCA',
    asbestos_presence_MPCA: 'MPCA',
    asbestos_presence_NOMCA: 'NOMCA',
    asbestos_presence_MCA_desc: 'Contiene amianto',
    asbestos_presence_MPCA_desc: 'Material probable de contener amianto',
    asbestos_presence_NOMCA_desc: 'No contiene amianto',
    // Common
    error: 'Error',
    otros: 'Otros',
    desconocido: 'Desconocido',
    // FloatingWindow
    selected_point: 'Punto seleccionado',
    layer_groups: 'Grupos de capas',
    layers: 'Capas',
    features: 'Elementos',
    add_new_feature: 'Añadir nuevo elemento',
    edit_feature: 'Editar elemento',
    area_properties: 'Propiedades del área',
    close: 'Cerrar',
    read_only: 'Solo lectura',
    read_only_mode: 'Modo solo lectura',
    complete_previous_step: 'Completar paso anterior',
    // Feature properties
    facade_photo: 'Fotografía de fachada',
    status: 'Estado',
    matrix_position: 'Posición en cuadrícula',
    n_elements_inside: 'Elementos en el interior',
    fx_creation: 'Fecha de creación',
    fx_modification: 'Fecha de modificación',
    fx_pending: 'Fecha pendiente',
    fx_in_progress: 'Fecha en progreso',
    fx_review: 'Fecha de revisión',
    fx_clear: 'Fecha completado',
    risk_final_value: 'Valor de riesgo final',
    risk_type_used: 'Tipo de riesgo utilizado',
    PENDING: 'Pendiente',
    IN_PROGRESS: 'En progreso',
    COMPLETED: 'Completado',
    REVIEWED: 'Revisado',
    address: 'Dirección',
    owner: 'Titularidad',
    current_use: 'Uso actual',
    municipality: 'Municipio',
    province: 'Provincia',
    area: 'Área',
    building_age: 'Antigüedad',
    building_creation_date: 'Fecha de construcción',
    is_asbestos: 'Contiene amianto',
    MCA: 'Contiene amianto',
    MPCA: 'Probable amianto',
    NOMCA: 'No contiene amianto',
    inspection_type: 'Tipo de inspección',
    PRELIMINAR: 'Teledetección',
    BASICO: 'Básico',
    DETALLADO: 'Detallado',
    RETIRADA: 'Retirada',
    VERTIDO: 'Vertido',
    element_type: 'Tipo de elemento',
    CUBIERTA: 'Cubierta',
    PARAMENTO: 'Paramento',
    BAJANTE: 'Bajante',
    // New closed enum (see AsbestosForm.jsx ELEMENT_TYPES).
    element_type_cubierta: 'Cubierta',
    element_type_fachada: 'Fachada',
    element_type_chimenea: 'Chimenea',
    element_type_bajantes: 'Bajantes',
    element_type_deposito: 'Depósito',
    element_type_numero_de_jardineras: 'Número de jardineras',
    element_type_calorifugados: 'Calorifugados',
    element_type_suelo_vinilico: 'Suelo vinílico',
    element_type_numero_de_juntas: 'Número de juntas',
    element_type_otros_elementos: 'Otros elementos',
    material: 'Material',
    // Material categories
    adhesives_cements_sealants: 'Adhesivos, Cementos, Selladores',
    asbestos_paper_board_roll: 'Papel de asbesto, Cartón, Rollo',
    automotive_materials_friction: 'Materiales Automotrices, Fricción',
    cement_pipes_boards_sheets_plastics: 'Tuberías de Cemento, Placas, Láminas, Plásticos',
    clay_compounds_paints_plasters: 'Arcilla, Compuestos, Pinturas, Yesos',
    electrical_mechanical_products: 'Productos Eléctricos y Mecánicos',
    flooring_tiles: 'Suelos, Azulejos',
    gaskets_packings_sealing_materials: 'Juntas, Empaques, Materiales de Sellado',
    household_products: 'Productos de Uso Doméstico',
    panels_drywall_wall_coverings: 'Paneles, Paneles de Yeso, Revestimientos',
    pipe_covering_block: 'Cubierta de Tuberías, Bloque',
    protective_clothing: 'Ropa Protectora',
    protective_fireproof_coatings: 'Recubrimientos Protectores, Ignífugos',
    raw_asbestos: 'Amianto Crudo',
    refractory_products: 'Productos Refractarios',
    rope_wick_cord_tape_cork: 'Cuerda, Mecha, Cordón, Cinta, Corcho',
    textiles_felts_fabrics: 'Textiles, Fieltros, Telas',
    // Material options - Category 1
    adhesives: 'Adhesivos',
    adhesive_cement: 'Cemento adhesivo',
    caulking: 'Calafateo',
    cement: 'Cemento',
    duct_adhesive: 'Adhesivo para conductos',
    finishing_cement: 'Cemento de acabado',
    furnace_cement: 'Cemento de horno',
    insulating_cement: 'Cemento aislante',
    joint_cement: 'Cemento para juntas',
    masonry_cement: 'Cemento de albañilería',
    putties: 'Masillas',
    mortar: 'Mortero',
    plastic_cement: 'Cemento plástico',
    sealant: 'Sellador',
    // Material options - Category 2
    asbestos_paper: 'Papel de amianto',
    corrugated_paper: 'Papel corrugado',
    flexible_board: 'Tablero flexible',
    millboard: 'Cartón prensado',
    permanent_board: 'Tablero permanente',
    roll: 'Rollo',
    vinyl_wallpaper: 'Papel pintado de vinilo',
    // Material options - Category 3
    brake_linings: 'Forros de freno',
    brake_pads: 'Pastillas de freno',
    brakes: 'Frenos',
    clutch_linings: 'Forros de embrague',
    disc_brakes: 'Frenos de disco',
    drum_brakes: 'Frenos de tambor',
    elevator_brake_shoes: 'Zapatas de freno de ascensor',
    transmission_plates: 'Placas de transmisión',
    // Material options - Category 4
    asbestos_board: 'Tablero de amianto',
    asbestos_sheets: 'Láminas de amianto',
    cement_pipes: 'Tuberías de cemento',
    plastics: 'Plásticos',
    stone_coating: 'Revestimiento de piedra',
    // Material options - Category 5
    acoustic_plaster: 'Yeso acústico',
    asphalt: 'Asfalto',
    filler: 'Relleno',
    finishing: 'Acabado',
    joint_compound: 'Compuesto para juntas',
    paint: 'Pintura',
    patching: 'Parcheo',
    plaster: 'Yeso',
    putty: 'Masilla',
    putty_compounds: 'Compuestos de masilla',
    // Material options - Category 6
    boilers: 'Calderas',
    cables_wires: 'Cables y alambres',
    electrical_boards: 'Tableros eléctricos',
    furnaces: 'Hornos',
    generators: 'Generadores',
    heating_ducts: 'Conductos de calefacción',
    pumps: 'Bombas',
    turbines: 'Turbinas',
    valve_rings: 'Anillos de válvula',
    valves: 'Válvulas',
    weather_resistant_jackets: 'Chaquetas resistentes a la intemperie',
    wiring_insulation: 'Aislamiento de cableado',
    // Material options - Category 7
    ceiling_tiles: 'Tejas del techo',
    tiles: 'Baldosas',
    flooring: 'Suelos',
    slabs: 'Losas',
    vinyl_linoleum_floors: 'Pisos de vinilo y linóleo',
    wall_tiles: 'Azulejos de pared',
    // Material options - Category 8
    braided_packing: 'Empaque trenzado',
    gasket_material: 'Material de junta',
    gaskets: 'Juntas',
    packing_material: 'Material de empaque',
    rope_packing: 'Empaque de cuerda',
    sheet_packing: 'Empaque de lámina',
    // Material options - Category 9
    agricultural_filler: 'Relleno agrícola',
    attic_insulation: 'Aislamiento de ático',
    cigarette_filters: 'Filtros de cigarrillos',
    clay_pots: 'Ollas de barro',
    fertilizer: 'Fertilizante',
    exhaust_hoods: 'Campanas de extracción',
    iron_stands: 'Soportes de hierro',
    ironing_board_covers: 'Fundas para tablas de planchar',
    lab_hoods: 'Campanas de laboratorio',
    potting_mixes: 'Mezclas para macetas',
    stove_mats: 'Alfombrillas para estufa',
    // Material options - Category 10
    acoustic_panels: 'Paneles acústicos',
    drywall: 'Panel de yeso',
    marine_panel: 'Panel marino',
    panels: 'Paneles',
    gypsum_board: 'Placa de yeso',
    wallboard: 'Tablero de pared',
    // Material options - Category 11
    block_insulation: 'Aislamiento de bloque',
    calcium_silicate: 'Silicato de calcio',
    duct_insulation: 'Aislamiento de conductos',
    insulation: 'Aislamiento',
    magnesia: 'Magnesia',
    pipe_insulation: 'Aislamiento de tuberías',
    preformed_pipe_wrap: 'Envoltura de tubería preformada',
    sponge_block: 'Bloque de esponja',
    sleeveless_jacket: 'Chaqueta sin mangas',
    // Material options - Category 12
    aprons: 'Delantales',
    asbestos_helmet: 'Casco de amianto',
    dust_masks: 'Máscaras antipolvo',
    glassblowers_mittens: 'Manoplas para sopladores de vidrio',
    gloves: 'Guantes',
    lab_gloves: 'Guantes de laboratorio',
    mittens: 'Manoplas',
    respirators: 'Respiradores',
    sleeves: 'Mangas',
    textile_garments: 'Prendas textiles',
    // Material options - Category 13
    asbestos_curtains: 'Cortinas de amianto',
    asbestos_spray: 'Aerosol de amianto',
    boiler_coating: 'Revestimiento de calderas',
    fireproof_blankets: 'Mantas ignífugas',
    fire_dampers: 'Compuertas cortafuegos',
    fire_doors: 'Puertas cortafuegos',
    fireproof_cement: 'Cemento ignífugo',
    fireproof_materials: 'Materiales ignífugos',
    insulating_coating: 'Revestimiento aislante',
    roof_coating: 'Revestimiento de techo',
    textured_coatings: 'Recubrimientos texturizados',
    coating: 'Recubrimiento',
    // Material options - Category 14
    asbestos_fiber: 'Fibra de amianto',
    fake_snow: 'Nieve falsa',
    // raw_asbestos already defined as category
    calsilite_silicate: 'Silicato de calsilita',
    talc_powder: 'Polvo de talco',
    transite: 'Transite',
    vermiculite: 'Vermiculita',
    // Material options - Category 15
    castables: 'Refractarios moldeables',
    refractory_brick: 'Ladrillo refractario',
    marinite: 'Marinita',
    refractory_cement: 'Cemento refractario',
    // Material options - Category 16
    asbestos_cord: 'Cordón de amianto',
    asbestos_rope: 'Cuerda de amianto',
    cork_coating: 'Revestimiento de corcho',
    foil_rope: 'Cuerda de lámina',
    tape: 'Cinta',
    wicking: 'Mecha',
    // Material options - Category 17
    asbestos_blanket: 'Manta de amianto',
    asbestos_canvas: 'Lona de amianto',
    asbestos_fabric: 'Tela de amianto',
    asbestos_felt: 'Fieltro de amianto',
    asbestos_lap: 'Solapa de amianto',
    asbestos_wool: 'Lana de amianto',
    asbestos_thread: 'Hilo de amianto',
    lagging: 'Calorifugado',
    roving: 'Mecha de fibras',
    textiles: 'Textiles',
    asbestos_type: 'Tipo de amianto',
    CRISOTILO: 'Crisotilo',
    ASBESTOS: 'Amianto',
    has_lab_measures: 'Tiene mediciones de laboratorio',
    lab_measure_ref_code: 'Código de referencia de laboratorio',
    lab_measure_note: 'Notas de laboratorio',
    risk_simplify_type: 'Tipo de riesgo simplificado',
    simple: 'Simple',
    form: 'Formulario',
    risk_form_value: 'Valor del formulario de riesgo',
    // Risk form phases
    questionsPhase1: 'Fase 1 - Exposición',
    questionsPhase2: 'Fase 2 - Estado',
    questionsPhase3: 'Fase 3 - Friabilidad',
    // Risk form questions and responses
    'inspections.equipmentLocation': '¿Dónde se encuentra el material?',
    'inspections.outdoorOrEncapsulated': 'En exterior o encapsulado',
    'inspections.occasionallyAccessible': 'Lugar accesible ocasionalmente',
    'inspections.largeAndWellVentilated': 'Local grande y bien ventilado (>1000m³)',
    'inspections.between2501000': 'Local entre 250-1000m³',
    'inspections.lessThan250': 'Local pequeño (<250m³)',
    'inspections.extentQuantity': '¿Cuál es la extensión/cantidad del material?',
    'inspections.smallQuantities': 'Cantidades pequeñas (<1m²)',
    'inspections.lessThan10': 'Menos de 10m²',
    'inspections.between1150': 'Entre 11-50m²',
    'inspections.moreThan51': 'Más de 51m²',
    'inspections.accessibility': '¿Cuál es la accesibilidad al material?',
    'inspections.inaccessible': 'Inaccesible',
    'inspections.difficultyAccessible': 'Difícilmente accesible',
    'inspections.easyAccessible': 'Fácilmente accesible',
    'inspections.highAccessible': 'Altamente accesible',
    'inspections.potentiallyExposed': '¿Cuántas personas están potencialmente expuestas?',
    'inspections.none': 'Ninguna',
    'inspections.between13': 'Entre 1-3 personas',
    'inspections.between410': 'Entre 4-10 personas',
    'inspections.moreThan10': 'Más de 10 personas',
    'inspections.technicalAccessibility': '¿Frecuencia de acceso técnico?',
    'inspections.never': 'Nunca',
    'inspections.occasionally': 'Ocasionalmente',
    'inspections.frequent': 'Frecuente',
    'inspections.materialStatus': '¿Cuál es el estado del material?',
    'inspections.noDamage': 'Sin daños',
    'inspections.littleDamage': 'Daños leves',
    'inspections.mediumDamage': 'Daños medios',
    'inspections.greatDamage': 'Daños graves',
    'inspections.asbestosVariety': '¿Qué variedad de amianto contiene?',
    'inspections.onlyChrysotile': 'Solo crisotilo',
    'inspections.amphibolesPresence': 'Presencia de anfíboles',
    'inspections.friability': '¿Cuál es la friabilidad del material?',
    'inspections.noFriability': 'No friable',
    'inspections.lowFriability': 'Friabilidad baja',
    'inspections.mediumFriability': 'Friabilidad media',
    'inspections.highFriability': 'Friabilidad alta',
    more: 'más',
    less: 'menos',
    description: 'Descripción',
    link: 'Enlace',
    open_in_new_tab: 'Abrir en nueva pestaña',
    obtaining_data: 'Obteniendo datos',
    no_info_to_display: 'No hay información para mostrar',
    // Form actions
    save: 'Guardar',
    delete: 'Eliminar',
    discard: 'Descartar',
    to: 'Ir a',
    asbestos: 'Amianto',
    edification: 'Edificación',
    attachments: 'Adjuntos',
    save_changes_title: 'Guardar cambios',
    save_changes_body: '¿Desea guardar los cambios realizados?',
    yes: 'Sí',
    no: 'No',
    delete_element_title: 'Eliminar elemento',
    delete_element_body: '¿Está seguro de que desea eliminar este elemento?',
    discard_changes_title: 'Descartar cambios',
    discard_changes_body: '¿Está seguro de que desea descartar los cambios?',
    // GeoJSON download
    download_geojson: 'Descargar GeoJSON',
    download_geojson_confirm_title: 'Descargar GeoJSON',
    download_geojson_confirm_message:
      '¿Estás seguro de que quieres descargar este archivo GeoJSON?',
    downloading_geojson: 'Descargando GeoJSON',
    geojson_downloaded_successfully: 'GeoJSON descargado correctamente',
    geojson_downloading_error: 'Error al descargar el GeoJSON',
    tooltipChangeGrid: 'Regenerar rejilla',
    regenerating_grid: 'Regenerando rejilla',
    grid_regenerated_successfully: 'Rejilla regenerada correctamente',
    changing_grid_status: 'Cambiando estado de cuadrícula',
    grid_status_changed_successfully: 'Estado de cuadrícula cambiado correctamente',
    grid_status_change_error: 'Error al cambiar estado de cuadrícula',
    no_grid_to_update: 'No hay cuadrícula para actualizar',
    from_layer: 'Desde capa',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    name_en: 'Nombre (EN)',
    // Fotointerpretation mode
    tooltipTeledeteccion: 'Modo fotointerpretación',
    tooltipFieldMode: 'Modo inspección en campo (tablet)',
    interpretation_enter: 'Interpretación',
    interpretation_active: 'Interpretación activa',
    interpretation_exit: 'Salir de interpretación',
    field_mode_enter: 'Modo campo',
    field_mode_active: 'Modo campo activo',
    field_mode_exit: 'Salir modo campo',
    exit_edition: 'Salir fotointerpretación',
    // Map controls
    zoom_in: 'Acercar',
    zoom_out: 'Alejar',
    center_aoi: 'Centrar en municipio',
    center_user: 'Mi ubicación',
    reset_rotation: 'Restablecer rotación',
    expand_map: 'Expandir mapa',
    collapse_map: 'Contraer mapa',
    fullscreen: 'Pantalla completa',
    exit_fullscreen: 'Salir de pantalla completa',
    open_settings: 'Ajustes del mapa',
    toggle_snap_guides: 'Activar/desactivar guías de ajuste',
    print: 'Imprimir mapa',
    locating: 'Localizando...',
    exit_draw_polygon_mode: 'Salir del modo de dibujo',
    name_es: 'Nombre (ES)',
    name_pt: 'Nombre (PT)',
    invalid_geometry: 'Geometría inválida',
    no_changes_made: 'No se han realizado cambios',
    creating_new_element: 'Creando nuevo elemento',
    element_created_successfully: 'Elemento creado correctamente',
    element_creating_error: 'Error al crear el elemento',
    updating_element: 'Actualizando elemento',
    element_updated_successfully: 'Elemento actualizado correctamente',
    element_updating_error: 'Error al actualizar el elemento',
    deleting_element: 'Eliminando elemento',
    element_deleted_successfully: 'Elemento eliminado correctamente',
    copying_element: 'Copiando elemento',
    element_copied_successfully: 'Elemento copiado correctamente',
    element_copying_error: 'Error al copiar elemento',
    element_selected: 'Elemento seleccionado',
    no_inventory_layer: 'No se encontró la capa de teledetección',

    // Context menu
    link_to: 'Enlace a...',
    change_grid_status: 'Cambiar estado de la rejilla a...',
    create_inventory_element: 'Crear elemento en teledetección...',
    change_asbestos_presence: 'Cambiar presencia de amianto a...',

    // Image gallery translations
    ASBESTOS_INVENTORY: 'Inventario de amianto',
    EDIFICATION_INVENTORY: 'Inventario de edificación',
    ASBESTOS_SUSCEPTIBILIDAD: 'Cribado de amianto',
    REMOVAL_PLAN: 'Plan de retirada',
    DISPOSAL_CERTIFICATE: 'Certificado de vertedero',
    no_images: 'Sin imágenes',
    uploading_image: 'Subiendo imagen',
    image_uploaded_successfully: 'Imagen subida correctamente',
    deleting_image: 'Eliminando imagen',
    image_deleted_successfully: 'Imagen eliminada correctamente',
    delete_attachment_title: 'Eliminar adjunto',
    delete_attachment_body: '¿Está seguro de que desea eliminar este adjunto?',
    expand_image: 'Ampliar imagen',
    download_image: 'Descargar imagen',
    delete_image: 'Eliminar imagen',
    close_image: 'Cerrar imagen',
    cannot_display_image: 'No se puede mostrar la imagen',
    show_more: 'Mostrar más',

    // Susceptibility layer fields
    ine_code: 'Código INE',
    codigo_ine: 'Código INE',
    ref_catastral: 'Número de referencia catastral',
    n_ref_catastral: 'Número de referencia catastral',
    numero_referencia_catastral: 'Número de referencia catastral',
    cadastral_reference: 'Número de referencia catastral',
    fecha_construccion: 'Fecha de construcción',
    construction_date: 'Fecha de construcción',
    susceptibilidad: 'Cribado de contener amianto',
    susceptibility: 'Cribado de contener amianto',
    uso_actual: 'Uso actual',
    propietario: 'Propietario',
    google_maps_link: 'Enlace a Google Maps',
    link_maps: 'Enlace a Google Maps',
    catastro_link: 'Enlace al catastro',
    link_catastro: 'Enlace al catastro',
    antiguedad: 'Antigüedad del edificio',
    antiguedad_edificio: 'Antigüedad del edificio',
    m2_catastro: 'Metros cuadrados catastrales',
    metros_cuadrados_catastrales: 'Metros cuadrados catastrales',
    provincia: 'Provincia',
    created_at: 'Fecha de creación',
    updated_at: 'Fecha de modificación',
    created_by: 'Creado por',
    updated_by: 'Modificado por',
    made_by: 'Creado por',

    // Susceptibility values
    'Muy Alta': 'Muy Alta',
    Alta: 'Alta',
    Media: 'Media',
    Baja: 'Baja',
    muy_alta: 'Muy Alta',
    alta: 'Alta',
    media: 'Media',
    baja: 'Baja',

    // Building use values
    'Servicios Públicos': 'Servicios Públicos',
    Industrial: 'Industrial',
    Agrícola: 'Agrícola',
    Retail: 'Retail',
    Oficinas: 'Oficinas',
    Residencial: 'Residencial',
    Otros: 'Otros',

    // Owner values
    Público: 'Público',
    Privado: 'Privado',
    publico: 'Público',
    privado: 'Privado',

    // Document management
    documents: 'Documentos',
    my_documents: 'Mis documentos',
    your_uploads: 'Tus subidas',
    censo_amianto: 'Teledetección amianto',
    susceptibilidad_amianto: 'Cribado amianto',
    layer_name_AMIANTO_CENSO: 'Teledetección de amianto',
    layer_name_AMIANTO_SUSCEPTIBILIDAD: 'Cribado de amianto',
    edificacion: 'Edificación',
    lab_measures: 'Muestras de laboratorio',
    LAB_MEASURES: 'Muestras de laboratorio',
    upload_document: 'Subir documento',
    upload_not_allowed: 'No tienes permiso para subir documentos',
    upload_requires_basic_permission: 'Requiere permiso de inspección básica',
    delete_document: 'Eliminar documento',
    download_document: 'Descargar documento',
    no_documents: 'No hay documentos',
    uploading_document: 'Subiendo documento',
    deleting_document: 'Eliminando documento',
    document_uploaded_successfully: 'Documento subido correctamente',
    document_deleted_successfully: 'Documento eliminado correctamente',
    error_uploading_document: 'Error al subir documento',
    error_deleting_document: 'Error al eliminar documento',
    error_loading_documents: 'Error al cargar documentos',
    delete_document_title: 'Eliminar documento',
    delete_document_confirmation: '¿Está seguro de que desea eliminar el documento "{{filename}}"?',
    search_documents: 'Buscar documentos',
    search_by_cadastral: 'Buscar por ref. catastral',
    search_by_municipality: 'Buscar por municipio',
    search_by_filename: 'Buscar por nombre de archivo',
    filter_by_category: 'Filtrar por categoría',
    filter_by_municipality: 'Filtrar por municipio',
    filter_by_user: 'Filtrar por usuario',
    all_categories: 'Todas las categorías',
    filename: 'Nombre de archivo',
    cadastral_ref: 'Ref. catastral',
    category: 'Categoría',
    size: 'Tamaño',
    uploaded_by: 'Subido por',
    uploaded_at: 'Fecha de subida',
    actions: 'Acciones',
    preview: 'Vista previa',
    save_feature_first_to_upload_documents:
      'Guarde el elemento primero para poder subir documentos',

    // Process management (RETIRADA/VERTIDO)
    processes: 'Procesos',
    removal_processes: 'Procesos de Retirada',
    dump_processes: 'Procesos de Vertido',
    add_process: 'Añadir proceso',
    no_processes: 'No hay procesos',
    no_process_permissions: 'No tiene permisos para ver procesos',
    error_loading_processes: 'Error al cargar procesos',

    // Process status options
    PENDIENTE: 'Pendiente',
    PROGRAMADA: 'Programada',
    EN_CURSO: 'En curso',
    COMPLETADA: 'Completada',

    // Process priority options
    ALTA: 'Alta',
    MEDIA: 'Media',
    BAJA: 'Baja',

    // Process fields
    priority: 'Prioridad',
    scheduled_date: 'Fecha programada',
    completed_date: 'Fecha completada',

    // Supplier assignment (renamed from "Partner" per CEO requirement)
    assigned_supplier: 'Empresa asignada',
    select_supplier: 'Seleccionar empresa',
    suppliers: 'Proveedores',

    // Removal-specific (RETIRADA)
    removal_plan: 'Plan de retirada aprobado',
    removal_plan_required_hint: 'Documento obligatorio',
    upload_removal_plan: 'Subir plan de retirada',
    file_too_large: 'El archivo es demasiado grande. Tamaño máximo: 50 MB',
    upload_error: 'Error al subir el archivo',
    building_permit_cost: 'Coste licencia de obra',
    removal_cost: 'Coste de retirada',
    new_roofing_cost: 'Coste nueva cubierta',
    costs: 'Costes',

    // Dump-specific (VERTIDO)
    disposal_certificate: 'Certificado de vertedero',
    disposal_certificate_required_hint: 'Certificado obligatorio de vertedero autorizado',
    upload_disposal_certificate: 'Subir certificado de vertedero',
    landfill_name: 'Nombre del vertedero',
    dump_location: 'Ubicación del vertedero',
    landfill_info: 'Información del vertedero',

    // Notes
    notes: 'Notas',

    // Document upload
    replace_document: 'Reemplazar documento',
    select_file: 'Seleccionar archivo',
    has_document: 'Documento adjunto',
    confirm_delete_process: '¿Está seguro de que desea eliminar este proceso?',
  },
  translation: {
    common: {
      yes: 'Si',
      no: 'No',
      connect: 'Conectar',
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      success: 'Éxito',
      error: 'Error',
    },
    error: { generic: 'Ocurrió un error' },
    user: {
      user_one: 'Usuario',
      user_other: 'Usuarios',
      notFound: 'Usuario no encontrado',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      username: 'Nombre de usuario',
      createdAt: 'Creado el',
      scope: 'Ámbito',
      primaryContact: 'Contacto principal',
      status: { active: 'Activo', inactive: 'Inactivo' },
      details: {
        roles: 'Roles',
        invitePermissions: 'Permisos para invitar',
        accessPermissions: 'Permisos de acceso',
        accessHint: 'Los permisos son de solo lectura',
      },
      // User management actions
      actions: 'Acciones',
      management: 'Gestión de usuario',
      deactivate: 'Desactivar usuario',
      activate: 'Activar usuario',
      deactivated: 'Usuario desactivado',
      activated: 'Usuario activado',
      setPrimary: 'Establecer como contacto principal',
      setPrimarySuccess: 'Usuario establecido como contacto principal',
      noRoles: 'Sin roles',
      noInvitePerms: 'Sin permisos de invitación',
      // Edición de perfil
      editProfile: 'Editar perfil',
      profileUpdated: 'Perfil actualizado',
      emailNotEditable: 'El email no se puede modificar',
      // Cambio de contraseña
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirmar nueva contraseña',
      passwordChanged: 'Contraseña cambiada correctamente',
      passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
    },
    permissions: {
      action: { view: 'Ver', edit: 'Editar' },
      level: {
        basic: 'básico',
        detailed: 'detallado',
        preliminary: 'teledetección',
        dump: 'vertedero',
        removal: 'retirada',
      },
    },
    entities: {
      municipality_one: 'Municipio',
      municipality_other: 'Municipios',
      organization_one: 'Organización',
      organization_other: 'Organizaciones',
      partner_one: 'Proveedor',
      partner_other: 'Proveedores',
      global_one: 'Admin',
    },
    supplier: {
      actions: 'Acciones',
      management: 'Gestión de proveedor',
      deactivate: 'Desactivar proveedor',
      activate: 'Activar proveedor',
      deactivated: 'Proveedor desactivado',
      activated: 'Proveedor activado',
      disconnect: 'Desconectar',
      disconnected: 'Proveedor desconectado',
      deactivateConfirm: {
        title: 'Desactivar proveedor',
        message: '¿Estás seguro de que quieres desactivar {{name}}?',
      },
      activateConfirm: {
        title: 'Activar proveedor',
        message: '¿Estás seguro de que quieres activar {{name}}?',
      },
      disconnectConfirm: {
        title: 'Desconectar proveedor',
        message:
          '¿Estás seguro de que quieres desconectar {{name}} de este municipio? Esto terminará el contrato.',
      },
      status: {
        active: 'Activo',
        inactive: 'Inactivo',
      },
    },
    municipality: {
      deactivate: 'Desactivar',
      activate: 'Activar',
      deactivated: 'Municipio desactivado',
      activated: 'Municipio activado',
      deactivateConfirm: {
        title: 'Desactivar municipio',
        message:
          '¿Estás seguro de que quieres desactivar {{name}}? Los usuarios ya no podrán acceder a este municipio.',
      },
      activateConfirm: {
        title: 'Activar municipio',
        message: '¿Estás seguro de que quieres activar {{name}}?',
      },
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    partnerConnection: {
      connectPartnerToMunicipality: 'Conectar proveedor a municipio',
      connectingPartner: 'Conectando proveedor',
      selectMunicipality: 'Seleccionar municipio',
      partnerConnectedSuccessfully: 'Proveedor conectado correctamente',
      errorConnectingPartner: 'Error al conectar proveedor',
    },
    orgManagement: {
      actions: 'Acciones',
      management: 'Gestión de organización',
      edit: 'Editar organización',
      updated: 'Organización actualizada',
    },
    entity: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      address: 'Dirección',
      website: 'Sitio web',
      cif: 'CIF',
      ine: 'INE',
      realIne: 'INE real',
      realIneDescription: 'Si se establece, indica que el INE es sintético',
      syntheticIne: 'INE sintético.',
      razonSocial: 'Razón Social',
      actions: 'Acciones',
      management: 'Gestión',
      edit: 'Editar',
      updated: 'Entidad actualizada',
      warning: {
        oneTime:
          '* Solo se puede cambiar una vez. Para modificarlo después, contacte al administrador.',
      },
      accessDenied: 'No tienes acceso a esta entidad',
      loadError: 'Error al cargar la entidad',
    },
    logs: {
      title: 'Logs del sistema',
      noFiles: 'No se encontraron archivos de log',
      lines: 'Líneas',
      empty: '(archivo vacío)',
      loadError: 'Error al cargar el archivo',
      selectFile: 'Elige un archivo de log',
    },
    muniStats: {
      title: 'Estadísticas',
      gridCompletion: 'Inspección de cuadrícula',
      completedCells: 'celdas completadas',
      censoInventory: 'Inventario teledetección',
      buildings: 'edificios',
      m2Asbestos: 'm² amianto',
      asbestosPresence: 'Presencia de amianto',
      processes: 'Procesos',
      noData: 'Sin datos',
      processStatus: {
        PENDIENTE: 'Pendiente',
        PROGRAMADA: 'Programada',
        EN_CURSO: 'En curso',
        COMPLETADA: 'Completada',
      },
    },
    login: {
      welcome: 'Bienvenido',
      subtitle: 'Inicia sesión para continuar',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@email.com',
      password: 'Contraseña',
      passwordPlaceholder: '••••••••',
      button: 'Iniciar sesión',
      loading: 'Iniciando sesión...',
      backToMap: '← Volver al mapa público',
      footer: 'Plataforma de gestión de amianto',
      forgotPassword: '¿Olvidaste tu contraseña?',
      invalidCredentials: 'Credenciales incorrectas',
      noRoles: 'No tienes roles asignados',
      deactivated: 'Tu municipio ha sido desactivado. Contacta con el administrador.',
      error: 'Error al iniciar sesión',
    },
    forgotPassword: {
      title: 'Recuperar contraseña',
      subtitle: 'Te enviaremos instrucciones por correo',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@email.com',
      button: 'Enviar instrucciones',
      loading: 'Enviando...',
      backToLogin: '← Volver al inicio de sesión',
      successMessage:
        'Si el correo existe, recibirás instrucciones para restablecer tu contraseña.',
      error: 'Ha ocurrido un error. Inténtalo de nuevo.',
    },
    resetPassword: {
      title: 'Nueva contraseña',
      password: 'Nueva contraseña',
      passwordPlaceholder: '••••••••',
      confirmPassword: 'Confirmar contraseña',
      confirmPasswordPlaceholder: '••••••••',
      hint: 'La contraseña debe tener al menos 8 caracteres',
      button: 'Actualizar contraseña',
      loading: 'Actualizando...',
      verifying: 'Verificando enlace...',
      invalidToken: 'Enlace inválido o expirado',
      requestNew: 'Solicitar nuevo enlace',
      successMessage: 'Tu contraseña ha sido actualizada correctamente.',
      goToLogin: 'Ir al inicio de sesión',
      minLength: 'La contraseña debe tener al menos 8 caracteres',
      mismatch: 'Las contraseñas no coinciden',
    },
    register: {
      userInfo: 'Información del Usuario',
      registerEntity: 'Registrar {{entity}}',
      loading: 'Creando cuenta...',
      submit: 'Registrarse',
      inviteNotFound: 'Invitación no encontrada',
      success: 'Registro completado con éxito',
      failure: 'No se pudo completar el registro',
    },
    header: {
      profile: 'Perfil',
      logout: 'Cerrar sesión',
      language: 'Idioma',
      open_invites: 'Invitaciones abiertas',
      my_documents: 'Mis documentos',
      logs: 'Logs del sistema',
      user_manual: 'Manual de usuario',
    },
    footer: {
      privacy: 'Política de privacidad y cookies',
      legal: 'Aviso legal',
      euAlt: 'Gobierno de España',
    },
    breadcrumbs: {
      dashboard: 'Panel',
      profile: 'Perfil',
      my_documents: 'Mis Documentos',
    },
    report: {
      title: 'Enviar feedback',
      tooltip:
        'Comparte ideas, sugerencias o problemas. Se puede adjuntar una captura de la pantalla actual.',
      comment: 'Comentario',
      comment_placeholder: 'Describe tu idea, sugerencia o problema...',
      send: 'Enviar',
      discard: 'Descartar',
      success: 'Feedback enviado',
      error: 'No se pudo enviar el feedback',
    },
    dashboard: {
      organizations: 'Organizaciones',
      municipalities: 'Municipios',
      partners: 'Proveedores',
      myEntity: 'Mi entidad',
      my: 'Mi',
    },
    entityForm: {
      userEmail: 'Correo del usuario',
      primaryUserEmail: 'Correo del usuario principal',
      name: 'Nombre',
      namePlaceholder: 'Nombre de la entidad',
      email: 'Correo electrónico',
      emailPlaceholder: 'Correo de la entidad',
      phoneNumber: 'Teléfono',
      phoneNumberPlaceholder: 'Teléfono de la entidad',
      address: 'Dirección',
      addressPlaceholder: 'Dirección de la entidad',
      website: 'Sitio web',
      websitePlaceholder: 'URL del sitio web',
      cif: 'CIF',
      cifPlaceholder: 'CIF (9 caracteres)',
      razonSocial: 'Razón Social',
      razonSocialPlaceholder: 'Razón social',
      ineCode: 'Código INE',
      ineCodePlaceholder: 'Código INE (5 caracteres)',
      municipalities: 'Municipios',
      municipalitiesPlaceholder: 'Selecciona municipios',
      contractStart: 'Inicio de contrato',
      contractStartPlaceholder: 'YYYY-MM-DD',
      contractEnd: 'Fin de contrato',
      contractEndPlaceholder: 'YYYY-MM-DD',
      contractDocument: 'Documento de contrato',
      uploadContract: 'Subir contrato',
      loading: 'Creando entidad...',
      submit: 'Crear entidad',
      passwordMismatch: 'Las contraseñas no coinciden',
      firstName: 'Nombre',
      firstNamePlaceholder: 'Introduce tu nombre',
      lastName: 'Apellido',
      lastNamePlaceholder: 'Introduce tu apellido',
      userPhoneNumber: 'Teléfono',
      userPhoneNumberPlaceholder: 'Introduce tu número de teléfono',
      username: 'Nombre de usuario',
      usernamePlaceholder: 'Elige un nombre de usuario (opcional)',
      password: 'Contraseña',
      passwordPlaceholder: 'Introduce tu contraseña',
      confirmPassword: 'Confirmar contraseña',
      confirmPasswordPlaceholder: 'Vuelve a introducir tu contraseña',
      secondLastName: 'Segundo apellido',
      secondLastNamePlaceholder: 'Introduce tu segundo apellido',
      cifError: 'El CIF debe tener exactamente 9 caracteres',
      ineError: 'El código INE debe tener exactamente 5 caracteres',
    },
    list: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      address: 'Dirección',
      website: 'Sitio web',
      ine: 'INE',
      razonSocial: 'Razón Social',
      cif: 'CIF',
      firstName: 'Nombre',
      lastName: 'Apellido',
      secondLastName: 'Segundo apellido',
      phoneNumber: 'Número de teléfono',
      isActive: 'Está activo',
      isPrimaryContact: 'Es contacto principal',
      username: 'Nombre de usuario',
      createdAt: 'Activo desde',
      inviterEmail: 'Invitado por',

      id: 'ID',
      inviterFullName: 'Nombre completo del invitador',
      scopeType: 'Tipo',
      targetName: 'Objetivo',
      scopeId: 'ID del ámbito',
      scopeName: 'Nombre invitado',
      roles: 'Roles',
      municipalityIds: 'IDs de municipios',
      municipalityNames: 'Nombres de municipios',
      status: 'Estado',
      contractStatus: 'Contrato',
      expiresAt: 'Expira en',
    },
    listPage: {
      invalidEntityType: 'Tipo de entidad inválido',
      list: 'Lista',
      cards: 'Tarjetas',
      add: 'Añadir',
      create: 'Crear',
      filterByName: 'Filtrar por nombre...',
      filterByIne: 'Filtrar por INE...',
      filterByRazonSocial: 'Filtrar por razón social...',
      entityType: {
        orgs: 'Organización',
        munis: 'Municipio',
        partners: 'Proveedor',
      },
    },
    usersList: {
      search: 'Buscar usuarios...',
    },
    entityTabs: {
      organization: 'Organización',
      municipalities: 'Municipios',
      partners: 'Proveedores',
      contracts: 'Contratos',
      noOrgLoaded: 'No se ha cargado la organización',
      close: 'Cerrar',
      map: 'Mapa',
      documents: 'Documentos',
      connectToMunicipality: 'Conectar con municipio',
      users: 'Usuarios',
      notifications: 'Notificaciones',
    },
    contracts: {
      partner: 'Proveedor',
      municipality: 'Municipio',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      status: 'Estado',
      actions: 'Acciones',
      noContracts: 'No se encontraron contratos',
      noContract: 'Sin contrato',
      active: 'Activo',
      expired: 'Expirado',
      upcoming: 'Próximo',
      viewDocument: 'Ver documento',
      downloadDocument: 'Descargar documento',
      disconnect: 'Desconectar proveedor',
      disconnectTitle: 'Desconectar proveedor',
      disconnectConfirmation: '¿Seguro que quieres desconectar {{partner}} de {{municipality}}?',
      disconnected: 'Proveedor desconectado correctamente',
      disconnectError: 'Error al desconectar proveedor',
    },
    actions: 'Acciones',
    organization: 'organización',
    partner: 'proveedor',
    plural: {
      organization: 'Organizaciones',
      municipality: 'Municipios',
      partner: 'Proveedores',
    },
    noDataAvailable: 'No hay datos disponibles',
    roles: {
      admin_full: 'Administrador — acceso total',
      admin_prelim: 'Administrador — solo teledetección',
      org_user_admin: 'Administrador de organización',
      org_user_basic_ins: 'Usuario de organización — inspección básica',
      org_user_detailed_ins: 'Usuario de organización — inspección detallada',
      org_user: 'Usuario de organización',
      municipality_user_admin: 'Administrador de municipio',
      municipality_user: 'Usuario de municipio',
      partner_user_admin: 'Administrador de proveedor',
      partner_user: 'Usuario de proveedor',
      partner_user_dump: 'Usuario de proveedor — gestión de vertedero',
      partner_user_removal: 'Usuario de proveedor — retirada',
      partner_user_detailed_ins: 'Usuario de proveedor — inspección detallada',
    },
    invites: {
      success: 'Invitación enviada correctamente',
      failure: 'Ocurrió un error',
      title: 'Invitaciones',
      decline: {
        decline: 'Rechazar',
        success: 'Invitación rechazada',
        error: 'No se pudo rechazar la invitación, inténtalo de nuevo',
        confirm: {
          title: 'Rechazar invitación',
          message: '¿Seguro que quieres rechazar esta invitación para {{email}}?',
          ok: 'Rechazar',
          cancel: 'Cancelar',
        },
      },
    },
    // Traducciones del panel de filtros
    no_filterable_layers: 'No hay capas con filtros disponibles',
    select_layer_to_filter: 'Seleccionar capa para filtrar',
    select_layer: 'Seleccionar capa',
    // Traducciones del panel de capas
    layer_panel: 'Panel de capas',
    layer_control: 'Control de capas',
    panel_close: 'Cerrar',
    collapse_panel: 'Minimizar panel',
    expand_panel: 'Expandir panel',
    tab_visualization: 'Visualización',
    tab_filters: 'Filtros',
    tab_dashboard: 'Panel de control',
    no_layers_available: 'No hay capas disponibles',
    layers_count: '{{count}} grupos de capas',
    filters_placeholder: 'Los filtros se configurarán aquí',
    dashboard_placeholder: 'El panel de control se mostrará aquí',
    opacity: 'Opacidad',
    style: 'Estilo',
    visualization_selector: 'Visualización',
    legend: 'Leyenda',
    loading_legend: 'Cargando leyenda',
    legend_unavailable: 'Leyenda no disponible',
    toggle_visibility: 'Alternar visibilidad',
    // Traducciones de capas base del mapa
    base_layer_selector: 'Capas base',
    pnoa_title: 'PNOA Aéreo',
    pnoa_description: 'Imágenes aéreas de España (PNOA)',
    osm_title: 'OpenStreetMap',
    osm_description: 'Mapa de calles colaborativo',
    catastro_title: 'Catastro',
    catastro_description: 'Parcelas catastrales de España',
    zonas_catastro_title: 'Catastro + Aéreo',
    zonas_catastro_description: 'Zonas catastrales sobre imágenes aéreas',
    cyclosm_title: 'CyclOSM',
    cyclosm_description: 'Mapa topográfico orientado al ciclismo',
    google_satellite_title: 'Google Satélite',
    google_satellite_description: 'Imágenes de satélite de Google',
    // header: { language: 'Idioma' },
    // Public Report Page
    publicReport: {
      title: 'Reportar ubicación de amianto',
      step1Label: 'Ubicación',
      step1Description: 'Información del lugar',
      step2Label: 'Contacto',
      step2Description: 'Datos de contacto (opcional)',
      municipality: 'Municipio',
      selectMunicipality: 'Seleccionar municipio',
      location: 'Ubicación en el mapa (opcional)',
      clickToSelect: 'Haga clic en el mapa para seleccionar una ubicación',
      address: 'Dirección',
      addressPlaceholder: 'Escriba la dirección o descripción del lugar',
      cadastralRef: 'Referencia catastral',
      cadastralRefPlaceholder: 'Ej: 0035603VF6703S0001',
      message: 'Descripción',
      messagePlaceholder: 'Describa la situación del amianto detectado',
      messageMinLength: 'La descripción debe tener al menos 10 caracteres',
      images: 'Fotografías',
      imagesHelp: '{{count}} de {{max}} imágenes (mínimo 1 requerida)',
      photos: 'Fotografías',
      optional: 'opcional',
      uploadPhoto: 'Subir foto',
      name: 'Nombre',
      namePlaceholder: 'Su nombre (opcional)',
      email: 'Correo electrónico',
      emailPlaceholder: 'Su correo electrónico (opcional)',
      phone: 'Teléfono',
      phonePlaceholder: 'Su teléfono (opcional)',
      contactOptional:
        'Los datos de contacto son opcionales pero facilitan el seguimiento del reporte.',
      contactOptionalLabel: 'Datos de contacto (opcional)',
      dataProtection:
        'Acepto la política de protección de datos y el tratamiento de mis datos para gestionar este reporte.',
      back: 'Anterior',
      next: 'Siguiente',
      submit: 'Enviar reporte',
      submittingTitle: 'Enviando reporte...',
      successTitle: 'Reporte enviado correctamente',
      successMessage:
        'Gracias por su reporte. El municipio ha sido notificado y revisará la información proporcionada.',
      successSubtitle:
        'Si proporcionó un correo electrónico, recibirá actualizaciones sobre el estado de su reporte.',
      submitAnother: 'Enviar otro reporte',
      errorTitle: 'Error',
      errorSubmitting: 'No se pudo enviar el reporte. Por favor, inténtelo de nuevo.',
      errorLoadingMunicipalities: 'No se pudieron cargar los municipios',
      invalidEmail: 'Por favor, introduzca un correo electrónico válido',
      invalidPhone: 'Por favor, introduzca un número de teléfono válido',
    },
    // Public Map Page
    publicMap: {
      title: 'Mapa de Amianto',
      login: 'Iniciar sesión',
      searchPlaceholder: 'Buscar municipio...',
      typeToSearch: 'Escribe al menos 2 caracteres para buscar',
      noResults: 'Sin resultados',
      selectedMunicipality: 'Seleccionado:',
      clickToReport: 'Click en el mapa para marcar una localización',
      noAoiTitle: 'Sin límites disponibles',
      noAoiMessage: 'Este municipio no tiene datos geográficos disponibles.',
      outsideBoundaryTitle: 'Fuera del límite',
      outsideBoundaryMessage: 'Por favor, haga clic dentro del límite del municipio seleccionado.',
      legend: 'Leyenda',
      asbestosInventory: 'Inventario de amianto',
      municipalityBoundary: 'Límite municipal',
      reportTitle: 'Seleccione una ubicación en el mapa para continuar',
      coordinates: 'Coordenadas',
    },
    // Notification Recipients Panel
    notificationRecipients: {
      title: 'Destinatarios de notificaciones',
      description:
        'Gestione las direcciones de correo que recibirán reportes públicos de amianto para este municipio.',
      recipientsCount: 'destinatarios',
      email: 'Correo electrónico',
      emailPlaceholder: 'nombre@ejemplo.com',
      name: 'Nombre',
      namePlaceholder: 'Nombre (opcional)',
      status: 'Estado',
      actions: 'Acciones',
      add: 'Añadir',
      active: 'Activo',
      inactive: 'Inactivo',
      noRecipients:
        'No hay destinatarios configurados. Añada direcciones de correo para recibir reportes públicos.',
      added: 'Destinatario añadido correctamente',
      deleted: 'Destinatario eliminado',
      errorLoading: 'No se pudieron cargar los destinatarios',
      errorAdding: 'No se pudo añadir el destinatario',
      errorDeleting: 'No se pudo eliminar el destinatario',
      errorToggling: 'No se pudo cambiar el estado del destinatario',
    },
  },
}
